module.exports = __webpack_public_path__ + "static/media/tree.28518c08.webp";